export default __webpack_public_path__ + "static/media/panelM2.bf65e5e9.png";